import React from 'react';
import { Target, Brain, Rocket, Star } from 'lucide-react';

const milestones = [
  {
    year: '2023',
    title: 'Conceptualized',
    description: 'Envisioned a revolutionary approach to AI-powered web development',
    icon: Target
  },
  {
    year: '2024',
    title: 'Launch',
    description: 'Officially launched our AI web development services',
    icon: Rocket
  },
  {
    year: '2024',
    title: 'First Projects',
    description: 'Successfully delivered our first AI-enhanced websites',
    icon: Star
  },
  {
    year: '2024',
    title: 'AI Innovation',
    description: 'Developed our core AI-powered development framework',
    icon: Brain
  }
];

export default function CompanyStory() {
  return (
    <section className="py-20 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h1 className="text-4xl font-bold text-gray-900 dark:text-white sm:text-5xl">
            Our Story
          </h1>
          <p className="mt-4 text-xl text-gray-600 dark:text-gray-300 max-w-3xl mx-auto">
            As a forward-thinking startup, we're revolutionizing web development through artificial intelligence,
            bringing innovative solutions to businesses of all sizes.
          </p>
        </div>

        <div className="mt-16">
          <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-4">
            {milestones.map((milestone, index) => {
              const Icon = milestone.icon;
              return (
                <div
                  key={milestone.year + milestone.title}
                  className="relative p-6 bg-white dark:bg-gray-800 rounded-xl shadow-lg hover:shadow-xl transition-shadow"
                >
                  <div className="absolute -top-4 left-6">
                    <div className="inline-flex items-center justify-center p-3 bg-purple-600 rounded-lg shadow-lg">
                      <Icon className="w-6 h-6 text-white" />
                    </div>
                  </div>
                  <div className="mt-8">
                    <p className="text-2xl font-bold text-purple-600">{milestone.year}</p>
                    <h3 className="mt-2 text-xl font-semibold text-gray-900 dark:text-white">
                      {milestone.title}
                    </h3>
                    <p className="mt-2 text-gray-600 dark:text-gray-300">
                      {milestone.description}
                    </p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        <div className="mt-20 bg-gray-50 dark:bg-gray-800 rounded-2xl p-8 md:p-12">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-3xl font-bold text-gray-900 dark:text-white">
                Our Mission
              </h2>
              <p className="mt-4 text-lg text-gray-600 dark:text-gray-300">
                To revolutionize web development through artificial intelligence, creating smarter,
                more engaging websites that deliver exceptional user experiences and drive business growth.
              </p>
              <div className="mt-8">
                <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">
                  Core Values
                </h3>
                <ul className="space-y-4">
                  <li className="flex items-center text-gray-600 dark:text-gray-300">
                    <span className="h-2 w-2 bg-purple-600 rounded-full mr-3"></span>
                    AI-Driven Innovation
                  </li>
                  <li className="flex items-center text-gray-600 dark:text-gray-300">
                    <span className="h-2 w-2 bg-purple-600 rounded-full mr-3"></span>
                    User-Centric Design
                  </li>
                  <li className="flex items-center text-gray-600 dark:text-gray-300">
                    <span className="h-2 w-2 bg-purple-600 rounded-full mr-3"></span>
                    Continuous Learning
                  </li>
                  <li className="flex items-center text-gray-600 dark:text-gray-300">
                    <span className="h-2 w-2 bg-purple-600 rounded-full mr-3"></span>
                    Ethical AI Development
                  </li>
                </ul>
              </div>
            </div>
            <div className="relative">
              <img
                src="https://images.unsplash.com/photo-1551434678-e076c223a692?auto=format&fit=crop&w=800&q=80"
                alt="AI web development"
                className="rounded-lg shadow-lg"
              />
              <div className="absolute inset-0 bg-gradient-to-r from-purple-600/20 to-blue-600/20 rounded-lg"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}